module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/projects.component.scss
// module id = 586
// module chunks = 1